import { memo } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPerson = props => /*#__PURE__*/_jsx("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32",
  className: `svg-icon ${props.className || ''}`,
  children: /*#__PURE__*/_jsx("path", {
    d: "M16.019 19.692c-5.438 0-9.846-4.408-9.846-9.846S10.581 0 16.019 0s9.846 4.408 9.846 9.846-4.408 9.846-9.846 9.846M1.25 27.385c0-4.615 4.923-7.692 6.565-7.692 1.09 0 3.828 2.05 8.204 6.154q6.565-6.154 8.204-6.154c1.642 0 6.565 3.077 6.565 7.692V32H1.25z"
  })
});
const Memo = /*#__PURE__*/memo(SvgPerson);
export default Memo;